module.exports = __webpack_public_path__ + "img/subject_3.ce7792b4.png";